import { render, staticRenderFns } from "./SearchAdvanceIAComponent.vue?vue&type=template&id=ec795c3a&scoped=true"
import script from "./SearchAdvanceIAComponent.vue?vue&type=script&lang=ts&setup=true"
export * from "./SearchAdvanceIAComponent.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./SearchAdvanceIAComponent.vue?vue&type=style&index=0&id=ec795c3a&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec795c3a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ec795c3a')) {
      api.createRecord('ec795c3a', component.options)
    } else {
      api.reload('ec795c3a', component.options)
    }
    module.hot.accept("./SearchAdvanceIAComponent.vue?vue&type=template&id=ec795c3a&scoped=true", function () {
      api.rerender('ec795c3a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/documentSearcher/components/SearchAdvanceIA/SearchAdvanceIAComponent.vue"
export default component.exports